import { fromAbsIndex, isWhite } from '../config/music';
import type { Settings } from '../state/settings';

/**
 * How the visible range is broken into display rows. Shared by the renderer
 * and the keymap so a row-aligned computer-keyboard layout always agrees with
 * what is drawn.
 *
 * The split is the exact middle, so the two rows always hold the same number of
 * keys (differing by one only when the total is odd). It is not snapped to a
 * white key or an octave boundary — doing either made one row jump in whole
 * steps while the other crept note by note. A row may therefore begin on a
 * black key, which the renderer and the keymaps both handle.
 */
export function splitIntoRows(s: Settings): number[][] {
  const all: number[] = [];
  for (let abs = s.startAbs; abs <= s.endAbs; abs++) all.push(abs);
  if (s.displayMode !== 'fit2' || all.length < 2) return [all];

  const split = Math.ceil(all.length / 2);
  return [all.slice(0, split), all.slice(split)];
}

export const whitesOf = (row: readonly number[]): number[] =>
  row.filter((abs) => isWhite(fromAbsIndex(abs).noteIndex));
